// The route manifest: the one description of every route in every context that
// `@platform/cdk-cell` (route table + ceiling guard), `@platform/authz` (route gate),
// `@platform/testing` (isolation suite) and the assistant tool generator read.
import { z } from 'zod';
export const AUTH_KINDS = ['tenant', 'platform-admin', 'public'];
export const authKindSchema = z.enum(AUTH_KINDS);
export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD'];
export const httpMethodSchema = z.enum(HTTP_METHODS);
/** `<resource>:<verb>`; both segments lower-kebab-case. */
export const ACTION_PATTERN = /^[a-z][a-z0-9-]*:[a-z][a-z0-9-]*$/;
export const actionSchema = z.string().regex(ACTION_PATTERN);
export const CONTEXT_PATTERN = /^[a-z][a-z0-9-]*$/;
export const contextNameSchema = z.string().regex(CONTEXT_PATTERN);
export const routeSchema = z.object({
    /** Bounded context the route belongs to (`platform`, `identity`, ...). */
    context: contextNameSchema,
    method: httpMethodSchema,
    /**
     * Path relative to the context's API root. The edge mounts each context at
     * `/api/<context>`; the manifest does not repeat that prefix.
     */
    path: z
        .string()
        .regex(/^\/(?:[A-Za-z0-9_.-]+|\{[A-Za-z][A-Za-z0-9]*\})(?:\/(?:[A-Za-z0-9_.-]+|\{[A-Za-z][A-Za-z0-9]*\}))*$|^\/$/),
    /** Stable id (`Tenants_list`) shared by the OpenAPI document, the zod table and the client. */
    operationId: z.string().regex(/^[A-Za-z][A-Za-z0-9_]*$/),
    auth: authKindSchema,
    action: actionSchema,
    /** Present when the operation is exempt from having an assistant tool, with the reason. */
    assistantExempt: z.string().min(1).optional(),
    /** The tool name (`<context>_<operationId>`) when the route is exposed to the assistant. */
    tool: z.string().optional(),
    summary: z.string().optional(),
    description: z.string().optional(),
    /** Path parameter names, in order of appearance. */
    pathParams: z.array(z.string()),
    /** Query parameter names. */
    queryParams: z.array(z.string()),
    hasBody: z.boolean(),
    /** The success status the operation returns (the lowest 2xx it declares). */
    successStatus: z.number().int().min(200).max(299),
});
export const routeManifestSchema = z.array(routeSchema);
/** `<context>_<operationId>`. */
export function toolNameFor(context, operationId) {
    return `${context}_${operationId}`;
}
export function parseRouteManifest(value) {
    return routeManifestSchema.parse(value);
}
//# sourceMappingURL=types.js.map